<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-14 14:53:11
 * @LastEditTime : 2025-08-08 13:50:11
 * @LastEditors  : yangxr
 * @Description  : 业务记账单明细-配件材料
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\accessorySheet\accessoryAccountingSheetDetail.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <div class="hr"></div>
                    <div class="card">
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" show-overflow-tooltip :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '共享推送'">
                                                <el-button size="mini" class="bottom_one"
                                                    @click="lookPicture(scope.row)">查看详情</el-button>
                                            </span>
                                            <span v-else-if="item.label == '单据编号'">
                                                <el-link :underline="false" type="success"
                                                    @click="GopurchaseSaleStoreDetail(scope.row)">{{ scope.row.code
                                                    }}</el-link>
                                            </span>
                                            <span v-else-if="item.label == '附件'">
                                                <el-link :underline="false" type="success"
                                                    @click="lookFile(scope.row)">查看</el-link>
                                            </span>
                                            <span v-else-if="item.label == '明细详情'">
                                                <el-link :underline="false" type="success"
                                                    @click="lookSheet(scope.row)">{{scope.row.money}}</el-link>
                                            </span>
                                            <span v-else-if="item.label == '单据类型'">
                                                <span>业务记账单</span>
                                            </span>
                                            <span v-else-if="item.label == '共享状态'">
                                                <span v-if="scope.row.shareStatus == 1">提交共享成功</span>
                                                <span v-if="scope.row.shareStatus == 2">提交共享失败</span>
                                                <span v-if="scope.row.shareStatus == 3">共享审核完成</span>
                                                <span v-if="scope.row.shareStatus == 4">共享审核驳回</span>
                                            </span>

                                            <span v-else-if="item.label == '单据类型'">
                                                <span>业务记账单</span>
                                            </span>
                                            <span v-else-if="item.label == '操作'">
                                                <el-button v-if="scope.row.shareStatus == 2 || scope.row.shareStatus == 4" class="bottom_one"
                                                    size="mini" @click="goPurchaseSaleStore(scope.row)">重推</el-button>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <!-- 附件查看 -->
            <el-dialog :visible.sync="fileDig" top="15vh" width="560px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">附件</span>
                <div>
                    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
                        stripe :height="screenHeight / 2 - 100" style="width: 100%" :data="fileTableData"
                        tooltip-effect="dark">
                        <el-table-column label="文件名称" prop="name" align="center">
                            <template slot-scope="scope">
                                <span>
                                    <el-link type="sucess" :underline="false" @click="lookFileDetail(scope.row)">{{
                                        scope.row.name }}</el-link>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="closeFile">关 闭</el-button>
                </span>
            </el-dialog>
            <!-- 明细详情 -->
            <el-dialog :visible.sync="sheetDig" top="15vh" width="980px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">附件</span>
                <div>
                    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
                        stripe :height="screenHeight / 2 - 100" style="width: 100%" :data="sheetData" tooltip-effect="dark" :span-method="objectSpanMethod">
                        <el-table-column label="业务大类" prop="name" align="center">
                                <span>{{low.businessType }}</span>
                        </el-table-column>
                        <el-table-column label="业务类型" prop="businessSmallType" align="center">
                        </el-table-column>
                        <el-table-column label="费用分摊部门" prop="costShareDepartment" align="center">
                        </el-table-column>
                        <el-table-column label="明细供应商" prop="mainSupplierName" align="center">
                        </el-table-column>
                        <el-table-column label="分摊金额" prop="sharedAmount" align="center">
                        </el-table-column>
                        <el-table-column label="总金额" prop="money" align="center">
                            <span>{{low.money }}</span>
                        </el-table-column>
                        <el-table-column label="事由" prop="resion" align="center">
                                <span>{{low.resion }}</span>
                        </el-table-column>
                        <el-table-column label="附件" prop="files" align="center">
                                <el-link :underline="false" type="success"
                                                    @click="lookFile(low)">查看</el-link>
                        </el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="sheetDig = false">关 闭</el-button>
                </span>
            </el-dialog>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { querySheetDatail } from "@/api/docking.js";
export default {
    components: {
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "单据编号", prop: "code", status: true, width: "200" },
                { label: "单据类型", prop: "businessTime", status: true, width: "100" },
                { label: "单据时间", prop: "createTime", status: true, width: "150" },
                { label: "主体公司", prop: "mainBodyName", status: true, width: "200" },
                { label: "业务大类", prop: "businessType", status: true, width: "150" },
                // { label: "业务小类", prop: "businessSmallType", status: true, width: "150" },
                { label: "共享项目编码", prop: "sharedProductCode", status: true, width: "150" },
                { label: "账期", prop: "businessTime", status: true, width: "100" },
                { label: "项目", prop: "sharedProductName", status: true, width: "auto" },
                { label: "明细详情", prop: "money", status: true, width: "100" },
                // { label: "事由", prop: "resion", status: true, width: "80" },
                // { label: "金额", prop: "money", status: true, width: "100" },

                // { label: "附件", prop: "attachment", status: true, width: "100" },
                { label: "共享单据编码", prop: "shareCode", status: true, width: "200" },
                { label: "共享状态", prop: "shareStatus", status: true, width: "100" },
                { label: "共享响应", prop: "shareResponse", status: true, width: "100" },
                { label: "操作", prop: "productionSite", status: true, width: "100", fixed: 'right' },
            ],
            tableData: [],
            pagesType: 0,
            tableParams: {
                sheetId: "",//筛选条件：主体
            },
            mainBodyList: [],
            fileTableData: [],
            fileDig: false,
            sheetDig: false,
            sheetData: [],
            low: {},
        };
    },
    watch: {
    },
    async created() {
        const query = this.$route.query
        this.tableParams.sheetId = query.id
        this.querySheetDatail();
    },
    methods: {
        GopurchaseSaleStoreDetail(row) {
            console.log(row)
            this.$router.push({ name: 'accessoryMaterialDetail', query: { code: row.sheetId, isIcps: true } })
        },
        goPurchaseSaleStore(row) {
            console.log(row)
            this.$router.push({ name: 'accessoryMaterial', query: { mainBodyId: row.mainBodyId, mainBodyName: row.mainBodyName, businessTime: row.businessTime } })
        },
        closeFile() {
            this.fileDig = false
        },
        lookFile(row) {
            let file = []
            if (!row.attachment) {
                this.$message.warning('暂无附件！')
                return
            }
            file = JSON.parse(row.attachment)
            this.fileTableData = file
            this.fileDig = true
        },
        lookSheet(row) {
            this.low = row
            this.sheetData = row.supplierList
            this.sheetDig = true
        },
        lookFileDetail(row) {
            window.open(row.url, "_blank");
        },
        querySheetDatail() {
            querySheetDatail(this.tableParams).then(res => {
                this.tableData = res.data
            })
        },
        objectSpanMethod({ rowIndex, columnIndex }) {
      // 需要合并的列索引：第一列(0)、第二列(1)、第五列(4)
      const mergeCols = [0, 5,6,7];

      if (mergeCols.includes(columnIndex)) {
        if (rowIndex === 0) {
          // 第一行显示，跨所有行
          return { rowspan: this.tableData.length, colspan: 1 };
        } else {
          // 其他行隐藏单元格
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 其他列正常显示
      return { rowspan: 1, colspan: 1 };
    }
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}
</style>
  